export default __webpack_public_path__ + "static/media/update_icon.0f990ef4.svg";